import styles from "./DetalhesColetaProdutos.module.css";
import Container from "../../../components/components-ui/Container/Container";
import Button from "../../../components/components-ui/Button/Button";
import api from "../../../services/Api";
// import Loading from '../../../components/components-ui/Loading/Loading'
import { BlockScreenLoading } from "../../../components/BlockScreenLoading";
import { Link } from "react-router-dom";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState, Fragment, useContext } from "react";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import Select from "react-select";
import { defaultStyle } from "../../../components/components-ui/SelectSearch/SelectSearch";
import { toast } from "react-toastify";
import { ProdutosMotoristaContext } from "../../../Provider/ProdutosMotoristaContext";

function DetalhesColetaProdutos() {
  const navigate = useNavigate();
  const { setItensContrapartida, itensContrapartida } = useContext(
    ProdutosMotoristaContext
  );

  const { id } = useParams();
  const [infoDetalheColeta, setInfoDetalheColeta] = useState([]);
  const [qtd, setQtd] = useState("");
  // const [showLoading, setShowLoading] = useState(false)
  const [blockScreen, setBlockScren] = useState(false);
  const [produtos, setProdutos] = useState([]);

  const [selectedOption, setSelectedOption] = useState(null);

  const handleChange = (event) => {
    // console.log(selectedOption);
    // setSelectedOption({
    //   idProd: event.target.value,
    //   text: event.target.options[event.target.selectedIndex].text,
    // });
    setSelectedOption(event);
  };

  async function getProdutos() {
    const response = await api.get(`/produtos`);
    console.log(response.data);
    setProdutos(response.data);
  }

  useEffect(() => {
    async function carregarDados() {
      try {
        setBlockScren(true);
        const response = await api.post(
          `/motorista/roteirodetalhecoleta/${id}`
        );
        setInfoDetalheColeta(response.data);
        await getProdutos();
      } catch (error) {
        console.log(error);
      } finally {
        setBlockScren(false);
      }
    }

    carregarDados();
  }, []);

  function adicionaProduto() {
    const infos = produtos.find((item) => item.id_brinde == selectedOption);

    const item = {
      IDBrinde: selectedOption,
      Brinde: infos?.brinde,
      QuantidadeSolicitada: qtd,
      Bonificacao: false,
      ValorUnitario: infos?.ValorVenda,
      ValorTotal: infos?.ValorVenda * Number(qtd),
      VolumeUnitario: infos?.VolumeUnitario,
      VolumeTotal: infos?.VolumeTotal * Number(qtd),
    };

    if (!selectedOption) {
      toast.error("Selecione uma opção de produto");
      return;
    }

    // Verificar se a quantidade está correta
    if (!qtd || qtd <= 0) {
      toast.error("Insira uma quantidade válida");
      return;
    }

    // Verificar se o item já foi adicionado
    const verificaItem = itensContrapartida.find(
      (item) => item.IDBrinde === selectedOption
    );

    if (verificaItem) {
      toast.error(
        "Item já existente! Se deseja alterar a quantidade exclua e adicione novamente."
      );
      return;
    }

    setItensContrapartida([...itensContrapartida, item]);
    setQtd("");
    setSelectedOption("");
  }

  function removeProduto(idBrinde) {
    const itens = itensContrapartida.filter(
      (item) => item.IDBrinde !== idBrinde
    );
    setItensContrapartida([...itens]);
  }

  return (
    <Container>
      <BlockScreenLoading loading display={blockScreen}>
        <strong> Carregando... </strong>
      </BlockScreenLoading>

      <div className={styles.content}>
        <div className={styles.btn_footer}>
          <Link
            to={`/local/detalhe-coleta/${id}`}
            className={styles.backButton}
          >
            <i className="fas fa-arrow-left"></i> Voltar
          </Link>
        </div>

        <Fragment>
          <h3>Inclusão de produto: {infoDetalheColeta?.id_coleta}</h3>
          <section className={styles.wrap_coleta}>
            {/* Listagem */}
            <ul>
              <li>
                <strong>Codigo</strong>: {infoDetalheColeta?.Codigo}
              </li>

              <li>
                <strong>Marca</strong>: {infoDetalheColeta?.nome_local}
              </li>
            </ul>
            <div className={styles.detalhe_coleta}>
              {/* Formulario */}
              <form onSubmit={(ev) => ev.preventDefault()}>
                <>
                  <select
                    id="selectOption"
                    value={selectedOption}
                    onChange={(e) => handleChange(e.target.value)}
                    required
                  >
                    <option value="">Selecione o produto</option>
                    {produtos.map((option) => (
                      <option key={option.id_brinde} value={option.id_brinde}>
                        {option.brinde}
                      </option>
                    ))}
                  </select>
                  {/* <Select
                      value={selectedOption}
                      onChange={handleChange}
                      options={produtos.map((values) => ({
                        label: values?.brinde,
                        value: values?.id_brinde,
                      }))}
                      placeholder="Selecione um produto"
                      styles={defaultStyle}
                      isClearable
                    /> */}

                  <input
                    type="number"
                    className={styles.input}
                    placeholder="QTDE"
                    value={qtd}
                    required
                    onChange={(e) => setQtd(e.target.value)}
                  />

                  <section className={styles.wrap_btn_coleta}>
                    <Button title="Inserir Produto" onClick={adicionaProduto} />
                  </section>

                  {/* Lista de produtos */}
                  {itensContrapartida.length == 0 ? (
                    ""
                  ) : (
                    <>
                      <table>
                        <thead>
                          <tr>
                            <th></th>
                            <th>Produto</th>
                            <th>Quantidade</th>
                          </tr>
                        </thead>

                        <tbody>
                          {itensContrapartida.map((item, index) => (
                            <tr key={index}>
                              <td>
                                <div className={styles.spanbutton}>
                                  <span
                                    onClick={(e) =>
                                      removeProduto(item.IDBrinde)
                                    }
                                  >
                                    <i className="fas fa-trash-alt"></i>
                                  </span>
                                </div>
                              </td>
                              <td>{item.Brinde}</td>
                              <td>{item.QuantidadeSolicitada}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </>
                  )}
                </>
              </form>
            </div>
          </section>
        </Fragment>
      </div>
    </Container>
  );
}

export default DetalhesColetaProdutos;
